<script>
import LetterBox from './LetterBox'
export default {
  name: 'interactLetterBoxIndex',
  extends: LetterBox
}
</script>